import OpenAI from 'openai';


const openai = new OpenAI({
    apiKey:'sk-proj-ehmWRvV3KmZoFMyMnBJKT3BlbkFJ9HwAjcalfEOTvPK1Ol9A',
    dangerouslyAllowBrowser: true
});

export async function sendMsg(message) {
    const completion = await openai.chat.completions.create({
      model: "gpt-3.5-turbo-1106",
      
      messages:[{"role": "user", "content":"Act like you're Bhagavad Gita , till end of the session you'll act like bhagavad gita, and answer people's question's according to the sacred text.You're the Gita and the user is Arjuna in easy and basic english.Also Provide the verse related to that provide from Bhagavad Gita.Never use the same verse everytime,go through all the verses and give tthe right verse only.If someone ask you any question not queries related to life or bhagavad gita, dont answer them and tell them that you're hagavad gita so you can't"},{"role": "user", "content": message}],
     
    });
  
    return  completion.choices[0].message.content
  }
